class BlogLandingFilter extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-blog-filter-dialog]');
      this.openButton = this.querySelector('[data-blog-filter-open]');
      this.closeButton = this.querySelector('[data-blog-filter-close]');
      this.applyButton = this.querySelector('[data-blog-filter-apply]');
      this.clearButton = this.querySelector('[data-blog-filter-clear]');
      this.countLabel = this.querySelector('[data-blog-filter-selected-count]');
      this.checkboxes = Array.from(this.querySelectorAll('input[type="checkbox"][data-tag-handle]'));
  
      this.openButton?.addEventListener('click', this.open);
      this.closeButton?.addEventListener('click', this.close);
      this.applyButton?.addEventListener('click', this.apply);
      this.clearButton?.addEventListener('click', this.clear);
      this.dialog?.addEventListener('click', this.handleDialogClick);
      this.dialog?.addEventListener('cancel', this.handleCancel);
  
      this.checkboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', this.updateCount);
      });
  
      this.updateCount();
    }
  
    disconnectedCallback() {
      this.openButton?.removeEventListener('click', this.open);
      this.closeButton?.removeEventListener('click', this.close);
      this.applyButton?.removeEventListener('click', this.apply);
      this.clearButton?.removeEventListener('click', this.clear);
      this.dialog?.removeEventListener('click', this.handleDialogClick);
      this.dialog?.removeEventListener('cancel', this.handleCancel);
    }
  
    open = () => {
      if (!this.dialog || this.dialog.open) return;

      this.syncCheckboxes();
      this.dialog.showModal();
      document.documentElement.setAttribute('scroll-lock', '');
    };

    close = async () => {
      if (!this.dialog?.open) return;

      this.dialog.classList.add('dialog-closing');
      await this.waitForAnimation(this.dialog);
      this.dialog.close();
      this.dialog.classList.remove('dialog-closing');
      this.unlockScroll();
    };

    syncCheckboxes = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const filterParam = urlParams.get('filter') || '';
      const filterTags = filterParam
        ? filterParam
            .replace(/\+/g, ',')
            .split(',')
            .map((t) => t.trim())
            .filter(Boolean)
        : [];

      if (window.location.pathname.includes('/tagged/')) {
        const taggedPart = window.location.pathname.split('/tagged/')[1] || '';
        taggedPart.split('+').forEach((t) => {
          const clean = t.trim();
          if (clean && !filterTags.includes(clean)) {
            filterTags.push(clean);
          }
        });
      }

      this.checkboxes.forEach((cb) => {
        cb.checked = filterTags.includes(cb.dataset.tagHandle);
      });
      this.updateCount();
    };

    clear = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const viewParam = urlParams.get('view');
      const blogUrl = this.dataset.blogUrl || window.location.pathname.split('/tagged/')[0];
      const targetUrl = new URL(blogUrl, window.location.origin);
      if (viewParam) {
        targetUrl.searchParams.set('view', viewParam);
      }
      window.location.href = targetUrl.toString();
    };

    apply = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const viewParam = urlParams.get('view');
      const blogUrl = this.dataset.blogUrl || window.location.pathname.split('/tagged/')[0];
      const selectedTags = this.checkboxes
        .filter((checkbox) => checkbox.checked)
        .map((checkbox) => checkbox.dataset.tagHandle)
        .filter(Boolean);

      const targetUrl = new URL(blogUrl, window.location.origin);
      if (viewParam) {
        targetUrl.searchParams.set('view', viewParam);
      }
      if (selectedTags.length > 0) {
        targetUrl.searchParams.set('filter', selectedTags.join(','));
      }

      window.location.href = targetUrl.toString();
    };
  
    handleDialogClick = (event) => {
      if (event.target === this.dialog) {
        this.close();
      }
    };
  
    handleCancel = (event) => {
      event.preventDefault();
      this.close();
    };
  
    updateCount = () => {
      if (!this.countLabel) return;
  
      const count = this.checkboxes.filter((checkbox) => checkbox.checked).length;
      this.countLabel.textContent = count > 0 ? `(${count})` : '';
    };
  
    unlockScroll = () => {
      document.documentElement.removeAttribute('scroll-lock');
    };
  
    waitForAnimation(element) {
      return new Promise((resolve) => {
        const fallback = window.setTimeout(resolve, 250);
  
        element.addEventListener(
          'animationend',
          () => {
            window.clearTimeout(fallback);
            resolve();
          },
          { once: true }
        );
      });
    }
  }
  
  if (!customElements.get('blog-landing-filter')) {
    customElements.define('blog-landing-filter', BlogLandingFilter);
  }
  